import * as React from "react";
import * as moment from "moment";
import { Component } from "react";

import Field from "components/FormElements/Field";
import SelectInput from "components/FormElements/SelectInput";
import {
  FIELD_PROP_NAMES,
  FieldPropsType,
} from "components/FormElements/types";
import { take } from "utils";

const DATE_PARTS = ["date", "month", "year"];

function dateStringToState(defaultValue: string): StateType {
  const state = { date: "Day", month: "Month", year: "Year" };

  if (!defaultValue) return state;

  const date = moment(defaultValue);

  return DATE_PARTS.reduce(
    (acc, datePart) => ({
      ...acc,
      [datePart]: date[datePart]().toString(),
    }),
    state,
  );
}

const monthName = (month: number): string => moment.months()[month];

interface PropsType extends Omit<FieldPropsType, "children" | "name"> {
  defaultValue?: string;
  maxYear: number;
  onChange(MomentDate): void;
}

interface StateType {
  date: string;
  month: string;
  year: string;
}

export default class DateSelectField extends Component<PropsType, StateType> {
  state = dateStringToState(this.props.defaultValue);

  onChange = ({ currentTarget: { name, value } }): void => {
    this.setState({ ...this.state, [name]: value }, this.submit);
  };

  submit = (): void => {
    const { state } = this;

    const numericDateParams = DATE_PARTS.reduce(
      (acc, key) => ({ ...acc, [key]: parseInt(state[key], 10) }),
      {},
    );

    const date = moment(numericDateParams);

    this.props.onChange(date);
  };

  render(): JSX.Element {
    const fieldProps = take(this.props, FIELD_PROP_NAMES);
    const { date, month, year } = this.state;
    const { maxYear, onBlur } = this.props;

    return (
      <Field className="date-select" {...fieldProps}>
        <div className="selects">
          <SelectInput
            name="month"
            onChange={this.onChange}
            options={[...Array(12)].map((_m, i) => ({
              label: monthName(i),
              value: `${i}`,
            }))}
            placeholder="Month"
            value={month}
            {...{ onBlur }}
          />

          <SelectInput
            name="date"
            onChange={this.onChange}
            options={[...Array(31)].map((_m, i) => ({
              label: `${i + 1}`,
              value: `${i + 1}`,
            }))}
            placeholder="Day"
            value={date}
            {...{ onBlur }}
          />

          <SelectInput
            name="year"
            onChange={this.onChange}
            options={[...Array(100)].map((_m, i) => ({
              label: `${maxYear - i}`,
              value: `${maxYear - i}`,
            }))}
            placeholder="Year"
            value={year}
            {...{ onBlur }}
          />
        </div>
      </Field>
    );
  }
}
